module.exports = __webpack_public_path__ + "static/media/IMG_4415a.c79ea846.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/lostWorld/IMG_4415a.JPG
// module id = 174
// module chunks = 0